var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 172,
    viewBox: "0 0 358 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08203 96.2789C58.632 135.108 117.089 121.95 148.16 97.6307C163.714 85.4293 168.906 77.7615 166.681 75.5964C165.138 74.1011 160.567 78.4912 152.611 82.989",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.309 72.9646C152.754 70.2013 159.203 65.0576 164.778 62.091C169.373 59.6986 171.957 61.4211 168.045 65.4524C156.702 77.1633 154.19 81.0032 152.79 82.7736",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.714 68.6469C147.96 65.196 151.464 61.9968 155.195 59.0772C157.731 57.0316 162.852 53.2037 164.886 54.6272C167.925 56.7565 152.922 68.5512 149.333 72.9652",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.869 66.2061C144.882 61.4213 155.243 48.9089 158.485 51.2893C159.681 52.1267 157.983 55.6077 151.306 62.2706",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 57.1512C32.9326 82.7741 85.1325 102.811 128.814 69.4842C131.865 67.1635 139.211 60.4408 141.879 57.833C144.75 55.0458 146.988 53.3831 148.675 53.9692C149.871 54.3999 148.352 57.2947 148.184 57.5579",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.198 151.666C271.064 154.903 260.079 169.482 264.701 170.9C268.429 172.042 275.887 163.169 277.192 158.676C277.192 158.676 283.957 157.596 288.775 149.969",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.885 167.697C259.992 160.52 266.498 149.174 268.391 147.551",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.081 31.957C331.253 53.2508 327.377 80.171 318.217 95.1713C305.819 115.464 277.496 128.87 268.307 137.563C260.492 144.95 254.702 158.611 258.279 167.843",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M330.674 1C342.414 9.54989 351.741 25.9335 355.587 51.7745C363.353 103.952 330.919 138.039 290.625 149.179",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.996 146.765C255.891 149.056 252.226 157.066 253.143 159.377C253.585 160.48 255.994 159.985 255.994 159.985",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands3);
export default __webpack_public_path__ + "static/media/hands3.201c3ec5b05ccf03cf25a47759dea5bb.svg";
export { ForwardRef as ReactComponent };